import React from 'react';
import LegalPageLayout, { H2, P, UL } from '../../components/LegalPageLayout';

export default function RefundPolicy() {
  return (
    <LegalPageLayout title="Refund & Cancellation Policy" lastUpdated="May 31, 2026" testId="refund-policy-page">
      <P>
        We want you to feel confident about your consultation on SecondDoctorOpinion.com. This policy
        explains when refunds are issued and how to request one.
      </P>

      <H2>Full Refund — When Available</H2>
      <UL>
        <li><strong>Before specialist assignment:</strong> If you cancel your case before it has been assigned to a specialist (typically within the first 2 hours of submission), you are entitled to a 100% refund.</li>
        <li><strong>No specialist available:</strong> If we are unable to assign a qualified specialist within 72 hours (e.g., for a rare subspecialty with no doctor on our current panel), you receive a full refund automatically.</li>
        <li><strong>Service failure:</strong> If we fail to deliver the opinion within the committed turnaround time (48 hours for Basic, 5 business days for Premium) and the delay is solely on our end.</li>
      </UL>

      <H2>Partial Refund</H2>
      <UL>
        <li><strong>After specialist assignment but before opinion submitted:</strong> 50% refund. The remaining 50% covers specialist review time already invested.</li>
        <li><strong>Premium → Basic downgrade:</strong> If you upgrade to Premium and later decide you do not need the video consultation (before it is scheduled), you receive a refund of the price difference (₹2,500 - ₹1,500 = ₹1,000).</li>
      </UL>

      <H2>No Refund</H2>
      <UL>
        <li>Once the medical opinion has been delivered to your dashboard, no refund will be issued — the service has been completed.</li>
        <li>Refunds are not provided based on disagreement with the medical opinion provided. A second opinion's value lies in its independence, not in confirming what you hoped to hear.</li>
        <li>If you provided false, fraudulent, or incomplete information that led to an inaccurate opinion.</li>
      </UL>

      <H2>How to Request a Refund</H2>
      <P>
        Email <strong>support@seconddoctoropinion.com</strong> or WhatsApp <strong>+91 88408 04798</strong> with:
      </P>
      <UL>
        <li>Your registered email address</li>
        <li>Your Case ID</li>
        <li>Reason for refund request</li>
      </UL>

      <H2>Processing Time</H2>
      <UL>
        <li>Refund decisions are communicated within 2 business days.</li>
        <li>Approved refunds via Stripe are credited back to the original card/account within 5-7 business days.</li>
        <li>Approved refunds via UPI are credited within 1-3 business days.</li>
      </UL>

      <H2>Disputes</H2>
      <P>
        If you are unsatisfied with a refund decision, please escalate to our Grievance Officer (see the
        Grievance Redressal page). We are committed to fair resolution.
      </P>
    </LegalPageLayout>
  );
}
